import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

export default function Chart({ data, type = "money", hideProjected = false }) {
  const datasets = [
    !hideProjected && {
      type: "line",
      label: "Dados Projetados",
      data: data.map((i) => i.projetado),
      borderColor: "rgba(146, 133, 249, 0.3)",
      borderWidth: 2,
      pointRadius: 5,
      pointBackgroundColor: "rgba(146, 133, 249, 0.5)",
      pointBorderWidth: 0,
    },
    {
      type: "bar",
      label: "Dados Alcançados",
      data: data.map((i) => i.alcancado),
      backgroundColor: "rgba(244, 69, 90, 0.35)",
      borderColor: "rgba(244, 69, 90, 0.35)",
      borderWidth: 1,
      borderRadius: 0,
      barPercentage: 0.6,
      categoryPercentage: 0.6,
    },
  ].filter(Boolean);

  return (
    <Bar
      data={{
        labels: data.map((i) => i.mes),
        datasets,
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        customType: type,
        scales: {
          y: {
            beginAtZero: true,
            grid: { color: "rgba(0,0,0,0.06)" },
            ticks: { font: { size: 11 } },
          },
          x: {
            grid: {
              display: true,
              color: "rgba(0,0,0,0.06)",
              drawBorder: false,
            },
            ticks: { font: { size: 11 } },
          },
        },
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              boxWidth: 10,
              usePointStyle: true,
              pointStyle: "circle",
              font: { size: 9 },
            },
          },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const value = ctx.raw;
                const chartType = ctx.chart.options.customType;

                if (chartType === "percent") {
                  return `${value?.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}%`;
                }

                if (chartType === "none") {
                  return `${value?.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}`;
                }

                return `R$ ${value?.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}`;
              },
            },
          },
        },
      }}
    />
  );
}
